export const API_ROUTES = {
  LOGIN: "/api/auth/login",
  REGISTER: "/api/auth/register",
  VERIFY: "/api/auth/verify",
  REFRESH: "/api/auth/refresh",
  CHANGE_PASSWORD: "/api/auth/change-password",
  CONFIGURACION: "/api/configuracion",
  PRODUCTOS: "/api/productos",
  CLIENTES: "/api/clientes",
  VENTAS: "/api/ventas",
  GASTOS: "/api/gastos",
  PRESUPUESTOS: "/api/presupuestos",
  REPORTES: "/api/reportes",
  USUARIOS: "/api/usuarios",
  CATEGORIAS: "/api/categorias",
};

export const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3000";

// Formato de moneda por defecto (se puede sobrescribir con configuración)
export const DEFAULT_CURRENCY_SYMBOL = "$";
export const DEFAULT_LOCALE = "es-AR";

// Helper para formatear precios
export const formatPrice = (value, symbol = DEFAULT_CURRENCY_SYMBOL) => {
  const numero = parseFloat(value) || 0;
  return `${symbol}${numero.toLocaleString(DEFAULT_LOCALE)}`;
};
